export const DATASOURCE_MICROSOFT = 'microsoft'
export const DATASOURCE_GOOGLE = 'google'
export const DATASOURCE_FACEBOOK = 'facebook'
export const DATASOURCE_LINKEDIN = 'linkedin'
